import { logSumoEvent, ULogApplication, ULogSeverity, ULogTag } from 'Common/api/SumoLogic';
import { getUserId } from 'Common/util/Auth';

declare const APP_NAME: string;

const logRpc = (method: string) => {
  let app = ULogApplication.DAZZLE;
  if (APP_NAME === 'compass') {
    app = ULogApplication.COMPASS;
  }

  void logSumoEvent({
    app,
    severity: ULogSeverity.INFO,
    userId: getUserId() ?? 'unknown',
    tag: ULogTag.Network,
    message: JSON.stringify({
      type: 'rpcCall',
      method
    })
  });
};

export default logRpc;
